import gql from 'graphql-tag';

export default gql`
  query projects(
    $institutionId: ID!
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    bookshopProjects(
      institutionId: $institutionId
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }

      edges {
        node {
          id
          name
          createdAt
          goal
          state
          requirements {
            budget
          }
          library {
            id
            name
          }
          suggestionsListId
          suggestionsListName
        }
      }
    }
  }
`;
